import { isDefined } from "@clipboard-health/util-ts";
import { type ShiftInviteMessageProps } from "@src/appV2/Chat/type";
import { parseShiftInviteChatMessage } from "@src/appV2/Chat/utils";
import { Button } from "@src/appV2/redesign/components/Button";
import { Pill } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { APP_V2_APP_EVENTS } from "../../lib";
import { logError } from "../../lib/analytics";
import { ChatActionCard } from "../../redesign/Chat/ChatActionCard";
import { ChatWidgetWrapper } from "../../redesign/Chat/ChatWidgetWrapper";
import { SHIFT_INVITES_FULL_PATH } from "../../redesign/WorkerShifts/path";

export function GroupShiftInviteRequestMessage(props: ShiftInviteMessageProps) {
  const history = useHistory();
  const { agentMessage } = parseShiftInviteChatMessage(props);

  if (!isDefined(agentMessage)) {
    logError(APP_V2_APP_EVENTS.GROUP_SHIFT_INVITE_REQUEST_MESSAGE_RENDER_FAILURE, {
      error: new Error("Worker facing message is missing"),
      metadata: {
        messageId: props.message.messageId,
      },
    });
    return null;
  }

  return (
    <ChatWidgetWrapper>
      <ChatActionCard
        message={agentMessage}
        pill={
          <Pill
            variant="outlined"
            size="small"
            label="Shift invite"
            backgroundColor={(theme) => theme.palette.background.quaternary}
            color={(theme) => theme.palette.intent?.warning.text}
            outlineColor={(theme) => theme.palette.intent?.warning.border}
            sx={{
              width: "fit-content",
            }}
          />
        }
      >
        <Button
          fullWidth
          variant="contained"
          size="small"
          onClick={() => {
            history.push(SHIFT_INVITES_FULL_PATH);
          }}
        >
          View Shift Invites
        </Button>
      </ChatActionCard>
    </ChatWidgetWrapper>
  );
}
